import React from 'react';
import { Spinner } from 'reactstrap';
import './loading.css';

export default class Loading extends React.Component {
    render() {
        let className = 'center loading';
        className += ' ' + this.props.extraClassName;
        return (
            <div className={className}>
                <br />
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="primary" />
                <br />
            </div>
        );
    }
}